export interface UserDataResponse {
    id: string;
    emails: Array<{
        email: string;
        verified: boolean;
        primary: boolean;
    }>;
    name: string;
    first_name: string;
    last_name: string;
    is_public: boolean;
    image_id: string;
}

export interface LoggedInUserData {
    publicId: string;
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
}

export const transformCurrentUserData = (
    userData: UserDataResponse,
): LoggedInUserData => {
    const loggedInUserData = {
        publicId: userData.id,
        email: userData.emails[0].email,
        fullName: userData.name,
        firstName: userData.first_name,
        lastName: userData.last_name,
    };

    return loggedInUserData;
};
